// extracted by mini-css-extract-plugin
export default {"container":"ComponentForLogoAndTitle_container__G6-t-","content":"ComponentForLogoAndTitle_content__e0JYC"};